var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit2X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u8F91") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u533A\\u5757",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-263.000000, -195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-41",
    transform: "translate(47.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(112.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(104.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.01,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.6092194 C15.3313708,14.6092194 15.6,14.8778485 15.6,15.2092194 C15.6,15.5074531 15.3824104,15.7548661 15.0973231,15.8013664 L15,15.8092194 L1,15.8092194 C0.66862915,15.8092194 0.4,15.5405902 0.4,15.2092194 C0.4,14.9109856 0.617589612,14.6635726 0.902676883,14.6170724 L1,14.6092194 L15,14.6092194 Z M10.323989,0.512963172 C10.7535658,0.083386451 11.4500472,0.083386451 11.8796239,0.512963172 L11.8796239,0.512963172 L14.5081806,3.14151979 C14.9377573,3.57109651 14.9377573,4.26757799 14.5081806,4.69715471 L14.5081806,4.69715471 L6.59750608,12.6078292 C6.39121606,12.8141192 6.11142676,12.9300117 5.81968862,12.9300117 L5.81968862,12.9300117 L3.191132,12.9300117 C2.58361877,12.9300117 2.091132,12.437525 2.091132,11.8300117 L2.091132,11.8300117 L2.091132,9.20145512 C2.091132,8.90971698 2.20702452,8.62992768 2.41331454,8.42363766 L2.41331454,8.42363766 Z M8.561,3.97278063 L3.291,9.24210826 L3.291,11.7291083 L5.778,11.7291083 L11.048,6.45978063 L8.561,3.97278063 Z M11.102,1.43210826 L9.409,3.12378063 L11.896,5.61178063 L13.589,3.91910826 L11.102,1.43210826 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2X);
export default __webpack_public_path__ + "static/media/edit@2x.29e54806.svg";
export { ForwardRef as ReactComponent };